module.exports = __webpack_public_path__ + "img/ascension-logo.3815cc0c.jpg";